module.exports = __webpack_public_path__ + "img/5.560b125d.svg";